var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sc-message--system", style: _vm.messageColors },
    [
      _vm._t(
        "default",
        function() {
          return [
            _vm._v("\n    " + _vm._s(_vm.data.text)),
            _vm.data.meta
              ? _c(
                  "p",
                  {
                    staticClass: "sc-message--meta",
                    style: { color: _vm.messageColors.color }
                  },
                  [_vm._v(_vm._s(_vm.data.meta))]
                )
              : _vm._e()
          ]
        },
        { message: _vm.data }
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bf652198", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bf652198","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/vue-beautiful-chat/src/messages/SystemMessage.vue
// module id = 1965
// module chunks = 120